<template>
  <div>
    <div
      id="static-backdrop-modal-edit-volunteer"
      class="modal grid justify-center content-center"
      data-backdrop="static"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg min-w-full">
        <div class="modal-content bg-theme-25 xs:mx-2">
          <div class="modal-header xs:mx-2 xs:px-0 md:px-3">
            <h4
              class="font-medium md:text-base xs:text-sm md:mr-auto font-bold"
            >
              แก้ไขผู้รับผิดชอบครัวเรือน
            </h4>
            <button
              class="btn xs:mr-0 md:mr-1 md:mb-2 xs:px-1 border-none exiterror"
              @click="closeModal('canceled')"
            >
              <XIcon class="w-5 h-5" />
            </button>
          </div>
          <div class="modal-body grid grid-cols-12 xs:pb-0">
            <div class="md:col-span-12 xs:col-span-12 mb-4">
              <p class="col-span-1 font-semibold mb-2">เจ้าหน้าที่ พม.</p>
              <p class="col-span-2 text-theme-37">
                {{ staffData.case_manager.title
                }}{{ staffData.case_manager.name }}
                {{ staffData.case_manager.surname }}
              </p>
            </div>
            <div class="md:col-span-12 xs:col-span-12">
              <label class="form-label text-theme-98">
                อพม. <span class="text-theme-5">*</span>
              </label>
            </div>
            <div class="md:col-span-12 xs:col-span-12 mb-3">
              <v-select
                class="selecthh"
                data-test="dropdown-volunteer"
                id="dropdown-volunteer"
                v-model="state.staffSelected"
                label="fullname"
                placeholder="กรุณาเลือก อพม."
                :options="staffArr"
                :clearable="false"
                :class="{ errorselect: v$.staffSelected.$errors.length }"
              >
                <template #selected-option="{ title, name, surname }">
                  <div style="display: flex; align-items: baseline">
                    <span>{{ title }}{{ name }} {{ surname }}</span>
                  </div>
                </template>
                <template #option="{ title, name, surname }">
                  <h3 style="margin: 0">{{ title }}{{ name }} {{ surname }}</h3>
                </template>
                <template #no-options="{}"> ไม่พบข้อมูล </template>
                <template #open-indicator="{ attributes }">
                  <span v-bind="attributes"><ChevronDownIcon class="w-5 h-5"/></span>
                </template>
              </v-select>
              <div
                class="input-errors"
                v-for="error of v$.staffSelected.$errors"
                :key="error.$uid"
              >
                <div class="error-msg">{{ error.$message }}</div>
              </div>
            </div>
          </div>
          <div class="modal-footer text-right">
            <button
              type="button"
              class="btn btn-primary w-15 font-medium"
              data-test="submit-staff-button"
              @click="submitForm"
            >
              บันทึก
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import useVuelidate from "@vuelidate/core";
import Swal from "sweetalert2";
import { ref, reactive, watch } from "vue";
import { required, helpers, minLength, maxLength } from "@vuelidate/validators";
import axios from "axios";
import store from "@/store";
const swalCustom = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-primary m-1',
    cancelButton: 'btn btn-outline-secondary m-1'
  }
});

const props = defineProps({
  editVolunteerModal: { type: Boolean, default: false },
  staffData: Object,
});

const emit = defineEmits(["clear-edit-volunteer-modal"]);
const staffData = props.staffData;
const vtUid = null;
const staffArr = ref([]);
const state = reactive({
  staffSelected: null,
});
const rules = {
  staffSelected: {
    required: helpers.withMessage("กรุณาเลือก อพม.", required),
  },
};
const v$ = useVuelidate(rules, state);

watch(
  () => props.editVolunteerModal,
  () => {
    if (props.editVolunteerModal) {
      cash("#static-backdrop-modal-edit-volunteer").modal("show");
      getDatatable();
    }
  }
);
const submitForm = async () => {
  const isFormCorrect = await v$.value.$validate();
  if (isFormCorrect) {
    try {
      await axios
        .put(`${process.env.VUE_APP_BASE_API}household/${staffData._id} `, {
          //id from get member
          update: {
            volunteer: {
              uid: state.staffSelected.uid,
              title: state.staffSelected.title,
              name: state.staffSelected.name,
              surname: state.staffSelected.surname,
              national_id: state.staffSelected.national_id,
            },
          },
        })
        .then((response) => {
          if (response.status === 200) {
            localStorage.setItem(
              "volunteerData",
              JSON.stringify(state.staffSelected)
            );
            swalCustom.fire({
              text:"สำเร็จ",
              icon: 'success',
              timer: 3000,
              confirmButtonText: "ปิด",
            }).then(()=>{
              closeModal("saved");
            })
          } else {
            swalCustom.fire({
              text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
              icon: "warning",
              //timer: 3000, //timeOut for auto-close
              confirmButtonText: "ปิด",
            });
          }
        });
    } catch (error) {
      console.log(error.message);
    }
  }
};
const clearValue = () => {
  state.staffSelected = null;
};
const closeModal = async (val) => {
  emit("clear-edit-volunteer-modal", val);
  v$.value.$reset();
  cash("#static-backdrop-modal-edit-volunteer").modal("hide");
  await clearValue();
};

const getDatatable = async () => {
  const url = `${process.env.VUE_APP_BASE_API}volunteer/getVolunteer`;
  const res = await axios.post(url, {
    uid: store.getters["userAuth/getTokenParsed"].subordinateVt,
  });

  if (res.status === 200) {
    staffArr.value = res.data;
    state.staffSelected = staffArr.value.filter(
      (cm) => cm.national_id === staffData.volunteer.national_id
    )[0];
  }
};
</script>

<style>
</style>